import {
  Alert,
  Badge,
  Button,
  Card,
  Form,
  Image,
  InputGroup,
  ListGroup,
} from "react-bootstrap"
import afrimoney from "../assets/images/afrimoney-logo-white.png"
import afrimoneyPink from "../assets/images/afrimoney-logo-pink.png"
import { formatMoney, updateObjectState } from "../utils/functions"
import { constants } from "../constants"
import { ConditionalView } from "../utils/components"
import { appConfigs } from "../configs/config"
import React, { useEffect } from "react"
import {
  FaCheck,
  FaChevronLeft,
  FaCopy,
  FaInfoCircle,
  FaPhone,
} from "react-icons/fa"
import CopyLinkComponent from "./CopyLink"

const color = "#a21b76"

export function AfrimoneyPaymentButton({ onClick }) {
  return (
    <div
      className={"text-center pointer"}
      style={{ backgroundColor: color, borderRadius: 20, padding: 0 }}
      onClick={() => onClick(constants.paymentProcessors.africell)}
    >
      <Image
        src={afrimoney}
        rounded={true}
        height={"60px"}
      />
    </div>
  )
}

export function AfrimoneyPayment({
  data,
  hasPaid,
  confirmPayment,
  setShowModal,
  setModal,
  selectedTicket,
  setData,
  validateForm,
}) {
  const [codeDialed, setCodeDialed] = React.useState(false)

  const isMobileDevice = /iPhone|Mobi|Android/i.test(navigator.userAgent)

  const getCode = (maskCPin = true) => {
    let code = appConfigs.afrimnoneyCode
    if (isMobileDevice && data.pinCode && data.pinCode.length === 4) {
      if (maskCPin) {
        code += `*xxxx`
      } else {
        code += `*${data.pinCode}`
      }
      code += "*1*1"
    }

    return `${code}#`
  }

  const copyTextToClipboard = async (text) => {
    if (!text) return false

    // Try modern Clipboard API first
    if (
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === "function"
    ) {
      try {
        await navigator.clipboard.writeText(text)
        return true
      } catch (err) {
        // fall through to fallback
      }
    }

    // Fallback: hidden textarea + execCommand
    try {
      const textarea = document.createElement("textarea")
      textarea.value = text
      textarea.setAttribute("readonly", "")
      textarea.style.position = "absolute"
      textarea.style.left = "-9999px"
      document.body.appendChild(textarea)

      textarea.select()
      textarea.setSelectionRange(0, textarea.value.length)

      const successful = document.execCommand("copy")
      document.body.removeChild(textarea)
      return successful
    } catch (err) {
      return false
    }
  }

  useEffect(() => {
    updateObjectState(setData, {
      afrimoneyOnDevice: isMobileDevice,

      // FOR TESTING PURPOSES ONLY - COMMENT OUT IN PRODUCTION
      // payment_transaction_id: "MP1234567.890323.23", // Mock transaction ID for demonstration
      // codeDialed: false,
    })
  }, [])

  // hasPaid = true

  return (
    <Card>
      <Card.Header
        className={"py-3"}
        style={{ backgroundColor: color }}
      >
        <h3 className={"text-center text-white"}>Pay with Afrimoney</h3>
      </Card.Header>
      <Card.Body>
        <ConditionalView
          condition={hasPaid}
          falseView={
            <>
              <Form className={"mt-4"}>
                <p className={"fw-bold"}>Afrimoney Phone / Account Number*</p>
                <InputGroup
                  className="mb-3"
                  size={"lg"}
                >
                  <InputGroup.Text id="countryCode">+232</InputGroup.Text>
                  <Form.Control
                    placeholder="e.g. 77123456"
                    aria-label="Afrimoney #"
                    aria-describedby="Phone number input"
                    type={"tel"}
                    id="phoneNumber"
                    value={data.account_number}
                    onChange={(e) => {
                      e.stopPropagation()
                      const val = e.target.value
                      if (val.length > 8) return
                      updateObjectState(setData, { account_number: val })
                    }}
                  />
                </InputGroup>

                {isMobileDevice && (
                  <>
                    {/*Add switch to show/hide pin with data.afrimoneyOnDevice*/}
                    <Card className={"border-1 border-primary px-3 mb-3 py-3"}>
                      <Form.Group className={"my-auto"}>
                        <Form.Check
                          type="switch"
                          id="afrimoneyOnDeviceSwitch"
                          label={"Afrimoney is on this Device"}
                          checked={data.afrimoneyOnDevice || false}
                          onChange={(e) => {
                            updateObjectState(setData, {
                              afrimoneyOnDevice: e.target.checked,
                              pinCode: "",
                            })
                          }}
                        />
                      </Form.Group>
                    </Card>

                    {data.afrimoneyOnDevice && (
                      <Form.Group className={"mb-4"}>
                        <p className={"fw-bold mb-0"}>
                          AfriMoney PIN Code (Optional)
                        </p>
                        <small>For faster payment</small>
                        <Form.Control
                          type={"tel"}
                          placeholder="e.g. 1234"
                          security={true}
                          maxLength={4}
                          max={4}
                          value={data.pinCode}
                          className={"border-2 mt-2"}
                          onChange={(e) => {
                            updateObjectState(setData, {
                              pinCode: e.target.value,
                            })
                          }}
                        />
                        <Alert
                          variant={"danger"}
                          className={
                            "text-start mt-1 bg-danger text-white fw-bold"
                          }
                        >
                          Your PIN is never stored, shared or leaves your
                          device.
                        </Alert>
                      </Form.Group>
                    )}
                  </>
                )}

                <div className="d-grid gap-2 mt-3 mb-4">
                  <Button
                    className={"text-white"}
                    disabled={!selectedTicket || validateForm()}
                    variant="primary"
                    size={"lg"}
                    style={{ backgroundColor: color }}
                    onClick={(e) => {
                      e.preventDefault()
                      setModal({
                        title: `Confirm Payment of ${
                          selectedTicket.currency
                        } ${formatMoney(
                          selectedTicket.retail_price * parseInt(data.quantity)
                        )}`,
                        body: "Please confirm to proceed. Afrimoney will text you if you have an account with them.",
                        interactive: true,
                      })
                      setShowModal(true)
                    }}
                  >
                    Initiate Payment
                  </Button>
                </div>
              </Form>
            </>
          }
          trueView={
            <>
              <Form>
                <div className={"text-center mb-4"}>
                  <FaInfoCircle
                    size={100}
                    color={color}
                    className={"fw-bold mb-4"}
                  />
                  <h3>{data.payment_transaction_id}</h3>
                  <p>Afrimoney Trans #</p>
                </div>

                <div className="d-grid gap-2 mb-3">
                  {data.codeDialed && (
                    <div>
                      <div className={"w-100"}>
                        <Button
                          variant="success"
                          className={"text-white py-3 fw-bolder w-100"}
                          size={"lg"}
                          onClick={(e) => {
                            e.preventDefault()
                            confirmPayment()
                          }}
                        >
                          <FaCheck className={"me-2"} />
                          Complete Payment
                        </Button>
                      </div>
                      <div>
                        <Button
                          variant={"link"}
                          className={"mt-4 w-100 fw-bolder"}
                          onClick={(e) => {
                            e.preventDefault()
                            updateObjectState(setData, { codeDialed: false })
                          }}
                        >
                          <FaChevronLeft className={"me-1"} />
                          Back
                        </Button>
                      </div>
                    </div>
                  )}

                  {!data.codeDialed && data.afrimoneyOnDevice && (
                    <div>
                      <Alert
                        variant={"success"}
                        className={"mb-1"}
                      >
                        Dial OR Copy the Short Code below to confirm your
                        payment
                      </Alert>
                      <div className={"d-flex gap-2"}>
                        <Button
                          className={"text-white"}
                          variant="primary"
                          size={"lg"}
                          style={{ backgroundColor: color }}
                          onClick={(e) => {
                            e.preventDefault()
                            updateObjectState(setData, { codeDialed: true })
                            window.location.href = `tel:${encodeURIComponent(
                              getCode(false)
                            )}`
                          }}
                        >
                          <FaPhone className={"me-2"} /> Dial {getCode(true)}
                        </Button>
                        <Button
                          variant={"secondary"}
                          size={"lg"}
                          onClick={async () => {
                            const code = getCode(false)
                            const ok = await copyTextToClipboard(code)
                            if (ok) {
                              updateObjectState(setData, { codeDialed: true })
                            } else {
                              // optional fallback UI
                              alert(
                                "Unable to copy automatically on this device. Please long-press the code and copy it manually."
                              )
                            }
                          }}
                        >
                          <FaCopy
                            className={"pointer text-end ms-auto my-auto"}
                            title={"Copy Short Code"}
                          />
                        </Button>
                      </div>
                    </div>
                  )}

                  {!data.codeDialed && !data.afrimoneyOnDevice && (
                    <div>
                      <Alert
                        variant={"info"}
                        className={"text-center fw-bold"}
                      >
                        <Alert.Heading className={"fw-bolder fs-2"}>
                          {getCode(true)}
                        </Alert.Heading>
                        Dial the code above on your Afrimoney phone to confirm
                        the payment
                      </Alert>

                      <div>
                        <Button
                          className={"text-white w-100"}
                          variant="primary"
                          size={"lg"}
                          style={{ backgroundColor: color }}
                          onClick={(e) => {
                            e.preventDefault()
                            updateObjectState(setData, { codeDialed: true })
                          }}
                        >
                          I've Confirmed the Payment
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </Form>
            </>
          }
        />
      </Card.Body>
    </Card>
  )
}
